import {createStyles, withStyles, withTheme} from "@material-ui/core";
import * as React from "react";
import CheckboxTree from "react-checkbox-tree";
import I18nMessage from "./i18n/I18nMessage";
import PortalFontIcon from "./PortalFontIcon";
import {I18nContext} from "../i18n/index";
import {useContext} from "react";
import {getLocalizedTaxonomyLabel} from "../utils/TaxonomyLabelUtil";


const treeIcons = (options) => ({
    check: <PortalFontIcon name={options.check || "check_box"} fontSize="inherit"/>,
    uncheck: <PortalFontIcon name={options.uncheck || "check_box_outline_blank"} fontSize="inherit"/>,
    halfCheck: <PortalFontIcon name={options.halfCheck || "indeterminate_check_box"} fontSize="inherit"/>,
    expandClose: <PortalFontIcon name={options.expandClose || "chevron_right"}/>,
    expandOpen: <PortalFontIcon name={options.expandOpen || "chevron_right"}/>,
    expandAll: null,
    collapseAll: null,
    parentClose: null,
    parentOpen: null,
    leaf: null,
});

const searchFacetsStyles = createStyles((theme: any) => ({
    searchFacets: theme.searchFacets,
}));

interface ISearchFacetsProps {
    classes?: any;
    theme?: any;
    className?: any;
    key?: any;
    root: any;
    noCascade?: boolean;
    onChange: (val: string[]) => void;
    selected: any;
    isTaxonomy: boolean;
    initiallyExpanded: string[];
    sorting: any;
}

const SearchFacets = (props: ISearchFacetsProps) => {
    const i18nContext = useContext(I18nContext);
    
    const {classes, className} = props;
    //@ts-ignore
    const [expanded, setExpanded] = React.useState<string[]>(props.initiallyExpanded);

    const transformer = (val: any = {}, sorting: any = {}, inSection: boolean = false) => {
        let children = null;
        if (val.children) {
            // do NOT sort sections, only facets/taxonomy
            children = val.children
            if (!inSection && val.value != 'section') {
                // first sort by label
                children = val.children.sort((a, b) => (a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1))
                // second sort by configuration (only for new configuration - facetsAdvancedSettings) - labels not existed in configuration will be shown first alphabetically, configured later
                if (sorting && Object.keys(sorting).length !== 0) {
                    const sortingArray = Array.from(new Map(Object.entries(sorting)).keys())
                    children = children.sort((a, b) => {
                        // This allows us to order the search facets as we declare them in the runtime config.
                        // Any facets not declared in the config map/array will always appear first, which is expected behavior. 
                        // The facets declared in the runtime config are additional facets, we'd want any default facets to appear first.
                        // The first value listed in the string will match the value given in the runtime configs search facets array.
                        const aSplit = a.value.split(' ')
                        const aValue = aSplit[aSplit.length-1];
                        const bSplit = b.value.split(' ')
                        const bValue = bSplit[bSplit.length-1];
                        return sortingArray.indexOf(aValue) - sortingArray.indexOf(bValue)
                    });
                }
            } else {
                inSection = true;
            }
            children = children.filter((c) => c.value).map((c) => {
                let sortingChilden;
                if (sorting instanceof Map) {
                    sortingChilden = sorting.get(val.value)
                }
                return transformer(c, sortingChilden, inSection);
            })
        }
        if (children && !children.length) {
            children = null
        }
        let textValue = val.isUiLabel ? undefined : val.label;
        
        if (props.isTaxonomy) {
            textValue = getLocalizedTaxonomyLabel(i18nContext, val.originalId, textValue);
        }
        
        return ({
            className: Array.isArray(val.value) ? val.value.join(' ') : val.value,
            key: val.id,
            label: <I18nMessage id={val.label} key={val.label} textValue={textValue} className={classes.searchFacet} variant="caption"/>,
            value: val.value,
            children
        });
    }
    return (
        <div key={props.root.param} className={className}>
            {/*@ts-ignore*/}
            <CheckboxTree
                nodes={[transformer(props.root, props.sorting, false)]}
                checked={props.selected}
                expanded={expanded}
                nameAsArray={true}
                expandOnClick={true}
                showNodeIcon={false}
                optimisticToggle={false}
                checkModel={'all'}
                onCheck={(checked) => {
                    props.onChange(checked);
                }}
                onExpand={ex => setExpanded(ex)}
                icons={treeIcons(props.theme.navTreeIcons || {})}
            />
        </div>
    );
};

SearchFacets.defaultProps = {
    root: {children: []},
    selected: [],
    initiallyExpanded: []
}
//@ts-ignore
export default withTheme(withStyles(searchFacetsStyles, {name: "SearchFacets"})(SearchFacets)) as any;
